import { useCallback } from "react";
import { useParams } from "react-router-dom";
import { NOOP } from "@web-monorepo/fetchers";
import RandomRemote from "./RandomRemote";
import { displayStudent } from "src/pods/random";
import { useToolkitRandomStore } from "src/pods/random/toolkitRandomStore";
import { displayOpen, displayClose, remoteClose } from "src/pods/realtime";
import { useAttendingStudents } from "src/pods/students/useStudentsFetcher";
import { useToolsFetcher } from "src/pods/toolkitData/useToolkitDataFetchers";
import { dispatchToolkitReduxAction } from "src/state/toolkitReduxStore";
import type { Student } from "src/pods/students";

export default function RandomRemoteContainer() {
  const { classId, mountPoint } = useParams<{ classId: string; mountPoint: string }>();
  const { data: students } = useAttendingStudents(classId ?? "", { enabled: !!classId });
  useToolsFetcher(classId ? { classId } : NOOP); // prefetch for display screen
  const { student: selectedStudent, previouslyChosenStudents } = useToolkitRandomStore();
  const mutablePreviouslyChosenStudents = [...previouslyChosenStudents];

  const handleDisplayOpen = useCallback(
    (path: string, action: unknown) => dispatchToolkitReduxAction(displayOpen(path, action)),
    [],
  );

  const handleDisplayClose = useCallback(() => dispatchToolkitReduxAction(displayClose()), []);

  const handleRemoteClose = useCallback(() => dispatchToolkitReduxAction(remoteClose()), []);

  const handleDisplayStudent = useCallback(
    (students: Student[], chosenStudent?: Student) =>
      dispatchToolkitReduxAction(displayStudent(students, chosenStudent)),
    [],
  );

  if (!classId || !mountPoint) return null;

  return (
    <RandomRemote
      classId={classId}
      mountPoint={mountPoint}
      students={students}
      selectedStudent={selectedStudent}
      previouslyChosenStudents={mutablePreviouslyChosenStudents}
      displayOpen={handleDisplayOpen}
      displayClose={handleDisplayClose}
      remoteClose={handleRemoteClose}
      displayStudent={handleDisplayStudent}
    />
  );
}
